export const theme = {
  formElementBaseHeight: '3rem',
  formElementBaseHeightSmall: '2rem',

  fontSize01: '0.25rem',
  fontSize02: '0.5rem',
  fontSize025: '14px',
  fontSize03: '1rem',
  fontSize04: '1.5rem',
  fontSize05: '2rem',
  fontSize06: '2.5rem',
  fontSize07: '3rem',
  fontSize08: '3.5rem',
  fontSize09: '4rem',

  spacing01: '0.5rem',
  spacing02: '1rem',
  spacing03: '1.5rem',
  spacing04: '2rem',
  spacing05: '2.5rem',
  spacing06: '3rem',

  lineHeightText: '170%',

  borderRadius: '4px',

  fontWeightNormal: '400',
  fontWeightMedium: '500',
  fontWeightBold: '600',

  colorPrimary20: '#D6FFF3',
  colorPrimary50: '#00A676',
  colorPrimary70: '#018861',

  colorUI80: '#525252',
  colorUI30: '#CDCDCD',
  colorUI20: '#f4f4f4',

  colorText50: '#414141',
  colorText70: '#2F2F2F',

  hoverTransitionSpeed: '0.05s',

  colorUtilityError: '#FE5F55',

  boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)',

  fieldColor: '#FB3640',
  fieldWeight: '4',
  fieldOpacity: '0.75',

  selectedNeighbouringFieldColor: '#55C1FF',
  selectedNeighbouringFieldWeight: '4',
  selectedNeighbouringFieldOpacity: '1',

  selectedNeighbouringFieldColor_0: 'aqua',
  selectedNeighbouringFieldColor_1: 'green',
  selectedNeighbouringFieldColor_2: 'blue',
  selectedNeighbouringFieldColor_3: 'orange',
  selectedNeighbouringFieldColor_4: 'violet',

  neighbouringFieldColor: '#B8B8B8',
  neighbouringFieldWeight: '4',
  neighbouringFieldOpacity: '0.75',

  fieldColor_0: '#FB3640',
  fieldColor_1: '#55C1FF',

  desktopLarge: '1800px',
};
